const NoDataMessage = ({className}:{className: string}) => {
    return (
        <span className={`no-pacing-data ${className}`}>
            Use <i className="px-1">Add</i> to schedule assessment.
        </span>
    )
};

export default NoDataMessage;
